// Module
var code = "<bp-header params=\"logo: 'bad-panda-logo'\"></bp-header>\r\n<div id=\"body-section\">\r\n  <bp-sidebar params=\"links: links\"></bp-sidebar>\r\n  <!-- ko if: view -->\r\n  <div data-bind=\"component: view\"></div>\r\n  <!-- /ko -->\r\n</div>\r\n<bp-footer></bp-footer>\r\n";
// Exports
module.exports = code;